import type { ContentItemsQueryParams } from '@/api/v4/content-items.api';
import { fetchFeedContentItems } from '@/api/v4/content-items.api';
import { QueryKey } from '@/config/query-client';
import { useQuery } from '@tanstack/react-query';

export const useFeedContentItems = (props?: {
  category?: ContentItemsQueryParams['category'];
}) => {
  const params: ContentItemsQueryParams = {
    category: props?.category,
    sort: 'uploadedDate',
    direction: 'desc',
  };

  return useQuery({
    queryKey: [QueryKey.FeedContentItems, params],
    queryFn: () => fetchFeedContentItems(params),
    staleTime: 1000 * 10 * 5,
    refetchInterval(query) {
      const data = query.state.data;
      if (!data) return false;
      const hasUnscannedImage = data.some(
        d => d.image?.scanningStatus === 'unscanned',
      );
      return hasUnscannedImage ? 2000 : false;
    },
  });
};
